<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">竞价大厅</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='type' :list='navlist' @datashow=tableshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div class="ml-border">
          <div >
            <div>
              <div style="display: flex;padding: 10px;justify-content: space-between;">
                <p style=" font-weight: bold;">
                  报价方式：<span style="color:red">{{ this.tenders[0] ? this.tenders[0].QuoteType == 1 ? '单次报价' : '多次报价' : '' }}</span> (注：报价方式为单次报价时，对方公司竞标价格显示为 **** ; 报价方式为多次时，对方公司竞标价格会显示出来) 
                </p>       
              </div>
            </div>
            <el-table :data="this.tenders" border style="font-size: 16px;" :row-style="{}"
              :cell-style="{ 'font-size': '14px' }" :header-row-style="{}" :fit="true">
              <el-table-column prop="Title" label="招标编号">
              </el-table-column>
              <el-table-column prop="Name" label="采购项目名称">
              </el-table-column>
              <el-table-column prop="price" :label="tenders[0] ? tenders[0].ShowBiddingType == 1 ? '竞标价格(元)' : '竞标价格(%)' : ''">
              </el-table-column>
              <el-table-column prop="CompanyName" label="竞标公司">
              </el-table-column>
              <el-table-column prop="Brand" label="品牌">
              </el-table-column>
              <el-table-column prop="UploadFiles" label="报价文件">
                <template slot-scope="scope">
                  <div style='color:#ff0000;'>
                    <div >{{ scope.row.UploadFiles}}
                      <el-col v-if="scope.row.UploadFiles && scope.row.UploadFiles != '****'">
                          <el-button type="primary" plain style="margin-top: 5px;" @click="deleteUploadFile(scope.row, scope.row.Id)">删除</el-button>
                      </el-col>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="UploadFilesTime" label="文件上传日期">
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Biddinglist",
  components: { leftmenu, leftlogin },
  data: function () {
    return {
      type: 3,
      Id: 0,
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      tenders: [],
      form: {},
      fileList: []
    };
  },
  updated() {
  },
  created() {
    var that = this;
    this.Id = this.$route.query.id;
    that.getData();
  },
  watch: {
    $route: async function (to, from) {

    }
  },
  mounted() {

  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Bidding/GetList?Id="+that.Id, null, r => {        
        that.tenders = r.response; 
        console.log(that.tenders)
      });
    },
    tableshow(item) {
      var that = this;
      if (item.Id == 1)
        that.$router.replace("/UserCenter");
      if (item.Id == 2)
        that.$router.replace("/Enroll");
      if (item.Id == 3)
        that.$router.replace("/Bidding");
      if (item.Id == 4)
        that.$router.replace("/BiddingHistory");
      return false;
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var date = new Date(dateString.replace(/-/g, "/"));
        return date;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleAvatarSuccess(item, res, file) {
      var that = this;
      console.log(res.response)
      that.$api.post("/Enroll/Post", { TenderId: that.Id, PackNum: item.PackNum, UploadFiles: res.response }, data => {
        if (data.success) {
          this.$notify({
            type: "success",
            message: "上传成功!",
            duration: 3000
          });
          location.reload();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
            showClose: true
          });
        }
      });
    },
    submit(item, TenderId) {
      var that = this;
      that.$api.post("/Bidding/Post", { TenderId: TenderId, ChildPackId: item.Id, PackNum: item.PackNum, price: item.jiage, Brand: item.pinpai, Remark: item.beizhu }, data => {
        if (data.success) {
          this.$notify({
            type: "success",
            message: "竞价成功!",
            duration: 3000
          });
          location.reload();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
            showClose: true
          });
        }
      });
    },
    deleteUploadFile(item, TenderId){
      var that = this;
      that.$api.post("/Bidding/DeleteUploadFile?biddingId="+ TenderId, {}, data => {
        if (data.success) {
          this.$notify({
            type: "success",
            message: "删除成功!",
            duration: 3000
          });
          location.reload();
        } else {
          this.$message({
            type: "error",
            message: data.msg,
            showClose: true
          });
        }
      });
    }
  },
  computed: {

  }
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  padding: 20px;
  width: 100%;
  border: 1px solid #CCCCCC;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.pagination {
  text-align: center;
}
</style>